import { Component, OnInit, OnDestroy, AfterViewInit, EventEmitter, Optional, ViewChild } from "@angular/core";
import { FormGroup, AbstractControl, RequiredValidator, Validators } from "@angular/forms";
import { GridOptions, GridApi, ColDef, TabToNextCellParams, CellPosition, RowSelectionOptions, IRichCellEditorParams } from 'ag-grid-community';

import { Observable, Subscription, Subject, forkJoin, from } from "rxjs";
import { tap, finalize } from "rxjs/operators";
import { BaseControlComponent } from "../base-control/base-control.component";

import { CoordinateSystem, GisLocationService } from "../../../gis/services/gis-location.service";
import { LoaderService } from "../../../common/services/loader.service";

import { DrillingEquipmentModel, CasingPlanModel, ensureWellComponentConfig, FormationModel, getContextLocation, getMultipleReadContextLocations, StatePlane, WellConfigType, WellConfigurationIndex, WellConfigurationData, WellDirection, WellSegmentModel, CasingTypeModel, CasingPlanComponent } from "../new-casing-plan/models/casing-plan.model";
import { deepClone } from "../../../builder/models/editor.model";
import { FlowButtonOverrideService } from "../../../flow/services/flow-button-override.service";
import { GridFormatterService } from "../../../common/services/grid-formatter.service";
import { DomainDefinitionService } from "../../../builder/services/domain-definition.service";
import { isDefined, segmentHasData, typeTransformer } from "../new-casing-plan/models/casing-plan-functions.model";
import { CheckboxEditorComponent, CheckboxEditorParams } from "../../../common/components/ag-grid/checkbox-editor.component";
import { Alert } from "../new-casing-plan/models/Alerts.model";
import { CasingConstructionRulesService } from "../new-casing-plan/services/casing-construction-rules.service";
import { CasingPlanAlertService } from "../new-casing-plan/services/casing-plan-alert.service";
import { ValidationRuleGenerator } from "../../../builder/services/validation-generator.service";
import { Button } from "../../../flow/models/flow.model";
import { ContextInteractionService } from "../../services/context-interaction.service";
import { isEmpty } from "../../../common/models/common-functions";
import { CheckboxRendererComponent } from "../../../common/components/ag-grid/checkbox-renderer.component";
import { CasingPlanSchematicModalComponent } from "./casing-plan-schematic-modal/casing-plan-schematic-modal.component";

@Component({
    selector: "casing-plan-grid",
    templateUrl: "./casing-plan-grid.component.html",
    styleUrls: ["./casing-plan-grid.component.scss"],
    providers: [CasingConstructionRulesService, CasingPlanAlertService, GisLocationService],
    standalone: false
})

export class CasingPlanGridComponent extends BaseControlComponent implements OnInit, OnDestroy, AfterViewInit, CasingPlanComponent {
    static componentName: string = "CasingPlanGridComponent";


    @ViewChild(CasingPlanSchematicModalComponent) modal: CasingPlanSchematicModalComponent;

    public formControl: AbstractControl;
    public _navigationStarted = false;

    dataSubscriptions: Subscription = new Subscription();

	public gridOptions: GridOptions;
	private gridApi?: GridApi;
    data: WellSegmentModel[];
    _validationGenerator: ValidationRuleGenerator = new ValidationRuleGenerator();
    _validRequiredObj: any;

    alertList: Alert[] = [];
    alerts: Subscription;
    observableAlerts: Subscription;
    observableAlertList: Alert[] = [];
    formations: FormationModel[];

    latitude: number;
    longitude: number;
    nad83Y: number;
    nad83X: number;

    proposedFormations: string[] = [];
    saveInProgress = new EventEmitter<boolean>(false);
    statePlane: CoordinateSystem;

    casingPlan: CasingPlanModel;
    _allFormations: FormationModel[] = [];
    _allCasingPlanStrings: CasingTypeModel[] = [];
    _allTools: DrillingEquipmentModel[] = [];
    _allPositions: number[] = [];

    get allPositions(): number[] {
        console.log("positions", this._allPositions);
        return this._allPositions;
    }

    _formationDescriptions: string[];
    _toolDescriptions: string[];
    _defaultPlaceHolderText = "Click to edit.";
	_validStringCasingTypeCodes = ['DP*', 'COND', 'MS1', 'SURF', 'I1', 'I2', 'PROD', 'PROD2', 'HOL1', 'PKR', 'L1', 'T1'];
    _validStringCasingTypeCodesNoPacker = ['DP*', 'COND', 'MS1', 'SURF', 'I1', 'I2', 'PROD', 'PROD2', 'HOL1','L1', 'T1'];
    _validStringCasingTypeCodesWithoutTubing = ['DP*', 'COND', 'MS1', 'SURF', 'I1', 'I2', 'PROD', 'PROD2', 'HOL1', 'L1'];
    _validStringCasingTypeCodesWithoutTubingOrLiner = ['DP*', 'COND', 'MS1', 'SURF', 'I1', 'I2', 'PROD', 'PROD2', 'HOL1',];
    _validStringCasingTypeCodesNoOpenHole = ['DP*', 'COND', 'MS1', 'SURF', 'I1', 'I2', 'PROD', 'PROD2', 'L1', 'T1'];
    _validStringCasingTypeCodesPackerNoOpenHole = ['DP*', 'COND', 'MS1', 'SURF', 'I1', 'I2', 'PROD', 'PROD2', 'PKR', 'L1', 'T1'];
    _validStringCasingTypeCodesNoDrivePipe = ['COND', 'MS1', 'SURF', 'I1', 'I2', 'PROD', 'PROD2', 'HOL1', 'L1'];
    _validToolTypes = ["CT", "RTA", "RTAF", "RTF", "SERV"];


    get applicationNumber(): string {
        let value: string = "";
        if (this.componentData && this.componentData.config && this.componentData.config.wellDataPoints) {
            const field = <WellConfigurationData>this.componentData.config.wellDataPoints.find(w => w.index === WellConfigurationIndex.ApplicationNumber);
            if (field!= null && field.location != null) {
                if (field.location.toString().endsWith(".value") === false) field.location = `${field.location}.value`;
                value = this.contextService.getContextData(field.location, this.componentContext);
            }
        }
        return value;
    }

    get wellDirection(): string {
        let value: string = (this.casingPlan != null) ? this.casingPlan.wellDirection : WellDirection.Vertical;
        if (this.componentData && this.componentData.config && this.componentData.config.wellDataPoints) {
            const field = <WellConfigurationData>this.componentData.config.wellDataPoints.find(w => w.index === WellConfigurationIndex.WellDirection);
            if (field.location.toString().endsWith(".value") === false) field.location = `${field.location}.value`;
            value = this.contextService.getContextData(field.location, this.componentContext);
        }
        if (value == null || value.length === 0) value = WellDirection.Vertical;
        return value;
    }

    get hasSegmentWithValues(): boolean {
        if (this.casingPlan == null || this.casingPlan.wellSegments == null) return false;
        return this.casingPlan.wellSegments.find(s => this.hasFieldBeenSet(s)) != null;
    }

    get hideUpdateButton(): boolean {
        return (!this.enableEditing || !this.isEnabled || this.casingPlan == null || this.casingPlan.schematic == null || this.casingPlan.schematic.length === 0);
    }



    get useNAD83(): boolean {
        let useNAD: boolean = true;
        if (this.componentData.config && this.componentData.config.useNAD != null) {
            useNAD = <boolean>this.componentData.config.useNAD;
        }
        return useNAD;
    }

    get measurementsValid(): boolean {
        if (!this.requirePositions) return true;
        if (this.casingPlan == null || this.casingPlan.wellSegments == null) return false;
        const hasField = this.casingPlan.wellSegments.filter(w => w.casingType.code !== 'PKR' && w.position > 0).map(p => this.hasFieldBeenSet(p));
        return hasField.length > 0 && hasField.findIndex(w => w === false) === -1;
    }

    get positionsValid(): boolean {
        if (this.casingPlan == null || this.casingPlan.wellSegments == null) return false;
        const positions = this.casingPlan.wellSegments.filter(w => w.casingType.code !== 'PKR' && this.hasFieldBeenSet(w)).map(p => p.position);
        return positions.length === 0 || positions.findIndex(p => p == null || p === 0) === -1;
    }

    get positionsDistinct(): boolean {
        if (this.casingPlan == null || this.casingPlan.wellSegments == null) return false;
        const positions = this.casingPlan.wellSegments.filter(w => this.hasFieldBeenSet(w)).map(p => p.position);
        if (positions.length === 0) return true;
        let distinct: boolean = true;
        for (let x = 1; x <= 11; x++) {
            const items = positions.filter(p => p === x);
            distinct = items.length <= 1;
            if (distinct === false) break;
        }
        return distinct;
    }

    get requirePositions(): boolean {
        let required: boolean = false;
        if (this.componentData && this.componentData.config) {
            required = this.componentData.config.enforcePositionRequirement;
        }
        return required;
    }


    constructor(
        public readonly location: GisLocationService,
        @Optional() public readonly buttonOverride: FlowButtonOverrideService,
        public readonly constructionService: CasingConstructionRulesService,
        public readonly alertsService: CasingPlanAlertService,
        public readonly loader: LoaderService,
        public _gridFormatterService: GridFormatterService,
        public _domainService: DomainDefinitionService,
        public readonly contextService: ContextInteractionService) {
        super(contextService);
    }
    wellType: string;
    wellTypeDescription: string;

    ngOnInit() {
        super.ngOnInit();

        this.formControl = this.formGroup.get(this.componentData.key);

        if (!this.isEdit) {
            for (let p = 0; p <= 11; p++) {
                this._allPositions.push(p);
            }
            if (this.buttonOverride) {
                this.buttonOverride.incrementFunction = this._incrementFunction.bind(this);
                this.buttonOverride.decrementFunction = this._decrementFunction.bind(this);
                this.buttonOverride.setValidatorNextButton(() => {
                    return (this.enableEditing && (!this.isCasingPlanValid() || !this.formGroup.valid))
                });
            }

            if (!this.componentData.config) {
                this.componentData.config = { wellDataPoints: ensureWellComponentConfig(WellConfigType.NewCasingPlan, []), useNAD: false };
            } else {
                this.componentData.config.wellDataPoints = ensureWellComponentConfig(WellConfigType.NewCasingPlan, this.componentData.config.wellDataPoints);
                if (this.componentData.config.useNAD == null) this.componentData.config.useNAD = true;
            }

            const storedData = this.getContextValue();
            if (!storedData) {
                this.casingPlan = new CasingPlanModel();
            } else {
                this.casingPlan = deepClone(storedData) as CasingPlanModel;
                if (this.casingPlan.wellSegments.length > 0 && this.casingPlan.wellSegments.findIndex(s => isDefined(s.casingType) && !isDefined(s.casingType.code) && isDefined((s.casingType as any).Code)) !== -1) {
                    const segments: WellSegmentModel[] = [];
                    for (let c = 0; c < this.casingPlan.wellSegments.length; c++) {
                        const segment = deepClone(this.casingPlan.wellSegments[c]);
                        const type = typeTransformer(segment.casingType);
                        segment.casingType = type;
                        segments.push(segment);
                    }
                    this.casingPlan.wellSegments = segments;
                };
            }
            if (isEmpty(this.casingPlan.creationDate)) this.casingPlan.creationDate = new Date();
            if (isEmpty(this.casingPlan.lastModifiedDate)) this.casingPlan.lastModifiedDate = new Date();
            this.gridOptions = this._gridFormatterService.BuildDefaultGridOptionsWithColumns(this.buildColumns(), false, false, false);
            // ag-Grid does not support popup cell editors (agRichSelectCellEditor with cellEditorPopup) together with full row editing -
            // the popup positioning breaks down when a whole row's editors open at once. This grid needs the popups to stay visible, so it opts out of full-row editing instead.
            this.gridOptions.editType = undefined;
			this.gridOptions.singleClickEdit = true;
			this.gridOptions.onGridReady = (params) => { this.gridApi = params.api; };
            this.gridOptions.stopEditingWhenCellsLoseFocus = true;
            this.gridOptions.pagination = false;
            this.gridOptions.headerHeight = 75;
            this.gridOptions.rowSelection = {
                mode: "singleRow",
                isRowSelectable: (rowNode): boolean => { return this.isRowSelectable(rowNode); },
                checkboxes: false
            } as RowSelectionOptions;
            this.gridOptions.onCellValueChanged = ($event) => this.saveCasingPlan();
            this.gridOptions.tabToNextCell = ($event) => this.tabToNextCell($event);
            this.validateControl();

            const propDepth = this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.ProposedTotalDepth));
            this.casingPlan.proposedTotalDepth = parseFloat(propDepth);
           
            this.casingPlan.wellDirection = <WellDirection>this.wellDirection;
            this.casingPlan.wellType = this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.WellType));
            this.wellType = this.casingPlan.wellType;
            this.casingPlan.wellTypeDescription = this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.WellTypeDescription));
            this.wellTypeDescription = this.casingPlan.wellTypeDescription;

            if (this.useNAD83) {
                this.nad83Y = this.getLatitudeFromContext();
                this.nad83X = this.getLongitudeFromContext();
                let statePlane = this.getStatePlane();
                if (statePlane === null || statePlane === undefined) {
                    console.log("Could not retrieve StatePlane, defaulting to south.");
                    statePlane = StatePlane.South;
                }

                this.statePlane = statePlane.toLowerCase() === StatePlane.South
                    ? CoordinateSystem.OHIO_SOUTH
                    : CoordinateSystem.OHIO_NORTH;
                const latLong = this.location.statePlaneToWebMercator(this.nad83X, this.nad83Y, this.statePlane, false);
                this.latitude = latLong[0];
                this.longitude = latLong[1];
            } else {
                this.latitude = this.getLatitudeFromContext();
                this.longitude = this.getLongitudeFromContext();
            }
           
            const urban = this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.UrbanArea));
            this.casingPlan.isUrbanizedArea = urban !== "NONURB";
            this.proposedFormations = this.readProposedFormations();
            this.casingPlan.surfaceLatitude = this.latitude;
            this.casingPlan.surfaceLongitude = this.longitude;
            this.casingPlan.newWell = false;

            const formation$ = this._domainService.getValues("FORMATION").pipe(
                tap((formations: any[]) => {
                    if (formations != null) {
                        formations.forEach(f => {
                            const model = new FormationModel();
                            model.code = f.Code;
                            model.definition = f.Definition;
                            model.isActive = f.isActive;
                            model.isRequired = f.isRequired;
                            model.lastModifiedDateUTC = f.LastModifiedDateUTC;
                            this._allFormations.push(model);
                        });
                        this._formationDescriptions = this._allFormations.map(x => x.definition);
                        const unselect = new FormationModel();
                        unselect.code = "";
                        unselect.definition = "No Formation Selected";
                        unselect.isActive = true;
                        unselect.isRequired = false;
                        unselect.lastModifiedDateUTC = new Date()
                        this._allFormations.unshift(unselect);
                    }
                })
            );
            const casingString$ = this._domainService.getValues("CSG_STRING").pipe(
                tap((casings: any[]) => {
                    if (casings != null) {
                        casings.forEach(c => {
                            const model = new CasingTypeModel();
                            model.code = c.Code;
                            model.definition = (c.Code !== 'HOL1') ? c.Definition : 'Open Hole';
                            model.isActive = c.isActive;
                            model.isRequired = c.isRequired;
                            model.lastModifiedDateUTC = c.LastModifiedDateUTC;
                            this._allCasingPlanStrings.push(model);
                        });
                    }                    
                })
            );

            const tool$ = this._domainService.getValues("RIG_TYP").pipe(
                tap((tools: any[]) => {
                    if (tools != null) {
                        tools.forEach(t => {
                            if (this._validToolTypes.findIndex(v => t.Code === v) !== -1) {
                                const model = new DrillingEquipmentModel();
                                model.code = t.Code;
                                model.definition = t.Definition;
                                model.isActive = t.isActive;
                                model.isRequired = t.isRequired;
                                model.lastModifiedDateUTC = t.LastModifiedDateUTC;
                                this._allTools.push(model);
                            }
                        });
                        this._toolDescriptions = this._allTools.map(x => x.definition);
                        const unselect = new DrillingEquipmentModel();
                        unselect.code = "";
                        unselect.definition = "No Tool Selected";
                        unselect.isActive = true;
                        unselect.isRequired = false;
                        unselect.lastModifiedDateUTC = new Date();
                        this._allTools.push(unselect)
                    }
                })
            );

            const subs$ = forkJoin([formation$, casingString$, tool$]).subscribe(
                (d) => {
                    this.data = this.buildDefaultRows();
                    if (this.gridApi) {
                        this.gridApi.sizeColumnsToFit();
                    }
                },
                (error) => {
                    console.error(error);
                }
            );
            this.dataSubscriptions.add(subs$);
        }
    }

    ngAfterViewInit() {
        if (this.gridApi) {
            this.gridApi.sizeColumnsToFit();
        }        
    }

    ngOnDestroy() {
        if (this.buttonOverride)
            this.buttonOverride.resetOverride();
        if (this.dataSubscriptions != null) this.dataSubscriptions.unsubscribe();
    }

    buildDefaultRows(): WellSegmentModel[] {
        let segments: WellSegmentModel[] = new Array<WellSegmentModel>();
        let defaultWellSegmentCasingTypes: CasingTypeModel[] = [];

        for (let x = 0; x < this._validStringCasingTypeCodes.length; x++) {
            let matchingCasingString = this._allCasingPlanStrings.filter(a => a.code == this._validStringCasingTypeCodes[x])[0];

            defaultWellSegmentCasingTypes.push(matchingCasingString);
        }

        for (let x = 0; x < defaultWellSegmentCasingTypes.length; x++) {
            let createDefaultSegment = true;
            let wellSegment = new WellSegmentModel();

            //Check if the casing plan already has a segment for this string, if so use it, if not create default
            if (this.casingPlan && this.casingPlan.wellSegments && this.casingPlan.wellSegments.length > 0) {
                let matchingSegments = this.casingPlan.wellSegments.filter(a => a.casingType.code == defaultWellSegmentCasingTypes[x].code);
                if (matchingSegments && matchingSegments.length > 0) {
                    wellSegment = matchingSegments[0] as WellSegmentModel;
                    createDefaultSegment = false;
                }
            }
            if (createDefaultSegment) {
                wellSegment.casingType = defaultWellSegmentCasingTypes[x];
                wellSegment.zoneTestedOrProduced = false;
            }

            segments.push(wellSegment)
        }
        return segments;
    }

    buildColumns(): ColDef[] {       

        let colDefs = [
            {
                headerClass: "wrapped",
                cellStyle: { 'white-space': 'normal' },
                headerName: 'Position',
                headerTooltip: 'Position',
                field: 'position',                
                editable: this.canEditColumn(this._validStringCasingTypeCodesNoPacker),
                valueFormatter: (params: any) => { 
                    let rv: string = "-";
                    if (params != null && params.value != null) {
                        rv = (params.value != 0) ? `String ${params.value}` : "-";
                    }
                    return rv;
                },
                tooltipValueGetter: (params: any) => { 
                    let rv: string = "-";
                    if (params != null && params.value != null) {
                        rv = (params.value != 0) ? `String ${params.value}` : "-";
                    }
                    return rv;
                },
                cellEditor: 'agRichSelectCellEditor',
                cellEditorPopup: true,
                cellEditorParams: () => {
                    return {
                        values: this.allPositions,
                        allowTyping: false,
                        formatValue: (value: any) => { return (value != 0) ? `String ${value}` : '-' }                                              
                    } as IRichCellEditorParams;
                },
                suppressMovable: true,
                suppressFiltersToolPanel: true,
                autoHeight: true,
                minWidth: 150,
                pinned: "left"
            } as ColDef,

            {
                headerClass: "wrapped",
                cellStyle: { 'white-space': 'normal' },
                headerName: 'Type Casing',
                headerTooltip: 'Type Casing',
                field: 'casingType.definition',
                tooltipField: 'casingType.definition',
                suppressMovable: true,
                suppressFiltersToolPanel: true,
                autoHeight: true,
                minWidth: 150,
                editable: false,
                pinned: "left"
            },
            {
                headerClass: "wrapped",
                cellStyle: { 'white-space': 'normal' },
                headerName: 'Borehole Diameter (in)',
                headerTooltip: 'Borehole Diameter (in)',
                field: 'boreholeDiameter',
                tooltipField: 'boreholeDiameter',
                suppressMovable: true,
                suppressFiltersToolPanel: true,
                valueFormatter: this.numberColumnFormatter('boreholeDiameter', 3, this._defaultPlaceHolderText, this._validStringCasingTypeCodesNoDrivePipe),  
                editable: this.canEditColumn(this._validStringCasingTypeCodesNoDrivePipe),
                sort: 'desc',
                autoHeight: true,
                minWidth: 100
            },
            {
                headerClass: "wrapped",
                cellStyle: { 'white-space': 'normal' },
                headerName: 'Borehole Depth (ft)',
                headerTooltip: 'Borehole Depth (ft)',
                field: 'boreholeDepth',
                tooltipField: 'boreholeDepth',
                suppressMovable: true,
                suppressFiltersToolPanel: true,
                valueFormatter: this.numberColumnFormatter('boreholeDepth', 3, this._defaultPlaceHolderText, this._validStringCasingTypeCodesNoDrivePipe),  
                editable: this.canEditColumn(this._validStringCasingTypeCodesNoDrivePipe),
                autoHeight: true,
                minWidth: 100
            },
            {
                headerClass: "wrapped",
                cellStyle: { 'white-space': 'normal' },
                headerName: 'Casing Diameter (in)',
                headerTooltip: 'Casing Diameter (in)',
                field: 'casingDiameter',
                tooltipField: 'casingDiameter',
                suppressMovable: true,
                suppressFiltersToolPanel: true,
                valueFormatter: this.numberColumnFormatter('casingDiameter', 3, this._defaultPlaceHolderText, this._validStringCasingTypeCodesNoOpenHole),
                editable: this.canEditColumn(this._validStringCasingTypeCodesNoOpenHole),
                autoHeight: true,
                minWidth: 100
            },
            {
                headerClass: "wrapped",
                cellStyle: { 'white-space': 'normal' },
                headerName: 'Casing Depth (ft)',
                headerTooltip: 'Casing Depth (ft)',
                field: 'casingLength',
                tooltipField: 'casingLength',
                suppressMovable: true,
                suppressFiltersToolPanel: true,
                valueFormatter: this.numberColumnFormatter('casingLength', 3, this._defaultPlaceHolderText, this._validStringCasingTypeCodesPackerNoOpenHole),
                editable: this.canEditColumn(this._validStringCasingTypeCodesPackerNoOpenHole),
                autoHeight: true,
                minWidth: 100
            },
            {
                headerClass: "wrapped",
                cellStyle: { 'white-space': 'normal' },
                headerName: 'Cement Top (ft)',
                headerTooltip: "Cement Top (ft)",
                field: "cementTop",
                tooltipField: "cementTop",
                suppressMovable: true,
                suppressFiltersToolPanel: true,
                valueFormatter: this.numberColumnFormatter('cementTop', 0, this._defaultPlaceHolderText, this._validStringCasingTypeCodesWithoutTubingOrLiner),
                editable: this.canEditColumn(this._validStringCasingTypeCodesWithoutTubingOrLiner),
                autoHeight: true,
                minWidth: 100
            } as ColDef,
            {
                headerClass: "wrapped",
                cellStyle: { 'white-space': 'normal' },
                headerName: 'Cement Volume (sacks)',
                headerTooltip: 'Cement Volume (sacks)',
                field: 'cementVolume',
                tooltipField: 'cementVolume',
                suppressMovable: true,
                suppressFiltersToolPanel: true,
                valueFormatter: this.numberColumnFormatter('cementVolume', 0, this._defaultPlaceHolderText, this._validStringCasingTypeCodesWithoutTubingOrLiner),
                editable: this.canEditColumn(this._validStringCasingTypeCodesWithoutTubingOrLiner),
                autoHeight: true,
                minWidth: 100
            }
        ] as ColDef[];
        if ((this.wellDirection !== WellDirection.Vertical)) {
            colDefs.push({
                headerClass: "wrapped",
                cellStyle: { 'white-space': 'normal', 'padding-left': 0 },
                headerName: 'Directional or Horizontal Kickpoint',
                headerTooltip: 'Directional or Horizontal Kickpoint',
                field: 'hasAngles',
                cellRenderer: CheckboxRendererComponent,
                cellRendererParams: {
                    action: this.toggleBoolean('hasAngles'),
                    field: 'hasAngles',
                    description: "Directional or Horizontal Kickpoint",
                    isVisible: this.canEditColumn(this._validStringCasingTypeCodesNoPacker),
                },
                cellEditor: CheckboxEditorComponent,
                cellEditorParams: {
                    action: this.toggleBoolean('hasAngles'),
                    field: 'hasAngles',
                    description: "Directional or Horizontal Kickpoint",
                    isVisible: this.canEditColumn(this._validStringCasingTypeCodesNoPacker),
                },
                tooltipValueGetter: this._gridFormatterService.formatBooleanToYesNo('hasAngles'),
                editable: this.canEditColumn(this._validStringCasingTypeCodesNoPacker),
                suppressMovable: true,
                suppressFiltersToolPanel: true,
                autoHeight: true,
                minWidth: 110
            } as ColDef);
        }
        colDefs.push({
            headerClass: "wrapped",
            cellStyle: { 'white-space': 'normal' },
            headerName: "Formation",
            headerTooltip: "Formation",
            field: "formation",
            suppressMovable: true,
            suppressFiltersToolPanel: true,
            autoHeight: true,
            editable: this.canEditColumn(),
            cellDataType: 'object',
            valueParser: (p) => p.newValue,
            valueFormatter: (params: any) => {
                let returnValue = "";
                returnValue = params && params.value && params.value.definition ? params.value.definition : 'No Formation Selected.';
                return returnValue;
            },
            tooltipValueGetter: (params) => {
                let returnValue = "";
                returnValue = params && params.value && params.value.definition ? params.value.definition : 'No Formation Selected.';
                return returnValue;
            },
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
            cellEditorParams: () => {
                return {
                    values: this._allFormations,
                    formatValue: (value: any) => {
                        let rv: string = value["definition"] ?? "No Formation Selected";
                        return rv;
                    }
                } as IRichCellEditorParams;
            },
            minWidth: 200
        } as ColDef);

        colDefs.push({
            headerClass: "wrapped",
            cellStyle: { 'white-space': 'normal' },
            headerName: 'Drilling Equipment',
            headerTooltip: 'Drilling Equipment',
            tooltipValueGetter:  (params) => {
                let returnValue = "";
                returnValue = params && params.value && params.value.definition ? params.value.definition : 'No Tool Selected.';
                return returnValue;
            },
            field: 'drillingEquipment',
            suppressMovable: true,
            suppressFiltersToolPanel: true,
            editable: this.canEditColumn(),
            autoHeight: true,
            valueParser: (p) => p.newValue,
            valueFormatter: (params) => {
                let returnValue = "";
                returnValue = params && params.value && params.value.definition ? params.value.definition : 'No Tool Selected.';
                return returnValue;
            },
            cellDataType: 'object',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
            cellEditorParams: () => {
                return {
                    values: this._allTools,
                    formatValue: (value: any) => {
                        let rv: string = value["definition"] ?? 'No Tool Selected.';
                        return rv;
                    }
                } as IRichCellEditorParams;
            },
            minWidth: 200
        })
        colDefs.push({
            headerClass: "wrapped",
            cellStyle: { 'white-space': 'normal' },
            headerName: 'Number of Centralizers',
            headerTooltip: 'Number of Centralizers',
            field: 'numberCentralizers',
            tooltipField: 'numberCentralizers',
            suppressMovable: true,
            suppressFiltersToolPanel: true,
            valueFormatter: this.numberColumnFormatter('numberCentralizers', 0, this._defaultPlaceHolderText, ['PROD', 'PROD2', 'SURF', 'I1', 'I2']),
            editable: this.canEditColumn(['PROD', 'PROD2', 'SURF', 'I1', 'I2']),
            autoHeight: true,
            minWidth: 125
        } as ColDef);

        colDefs.push({
            headerClass: "wrapped",
            cellStyle: { 'white-space': 'normal', 'padding-left' : 0 },
            headerName: "Tested",
            headerTooltip: "Tested",
            field: "tested",
            cellRenderer: CheckboxRendererComponent,
            cellRendererParams: {
                action: this.toggleBoolean("tested"),
                field: "tested",
                description: "Tested",
                isVisible: this.canEditColumn(['PROD', 'PROD2', 'I1', 'I2', 'L1', 'T1'])
            },
            cellEditor: CheckboxEditorComponent,
            cellEditorParams: {
                action: this.toggleBoolean("tested"),
                field: "tested",
                description: "Tested",
                isVisible: this.canEditColumn(['PROD', 'PROD2', 'I1', 'I2', 'L1', 'T1']),
            },
            tooltipValueGetter: this._gridFormatterService.formatBooleanToYesNo("tested"),
            editable: this.canEditColumn(['PROD', 'PROD2', 'I1', 'I2', 'L1', 'T1']),
            suppressMovable: true,
            suppressFiltersToolPanel: true,
            autoHeight: true,
            minWidth: 110
        } as ColDef);

        colDefs.push({
            headerClass: "wrapped",
            cellStyle: { 'white-space': 'normal', 'padding-left': 0 },
            headerName: "Produced",
            headerTooltip: "Produced",
            field: "produced",
            cellRenderer: CheckboxRendererComponent,
            cellRendererParams: {
                action: this.toggleBoolean("produced"),
                field: "produced",
                description: "Produced",
                isVisible: this.canEditColumn(['PROD', 'PROD2' , 'I1', 'I2', 'L1', 'T1'])
            },
            cellEditor: CheckboxEditorComponent,
            cellEditorParams: {
                action: this.toggleBoolean("produced"),
                field: "produced",
                description: "Produced",
                isVisible: this.canEditColumn(['PROD', 'PROD2', 'I1', 'I2', 'L1', 'T1']),
            },
            tooltipValueGetter: this._gridFormatterService.formatBooleanToYesNo("produced"),
            editable: this.canEditColumn(['PROD', 'PROD2', 'I1', 'I2', 'L1', 'T1']),
            suppressMovable: true,
            suppressFiltersToolPanel: true,
            autoHeight: true,
            minWidth: 110
        } as ColDef);


        colDefs.push({
            headerClass: "wrapped",
            cellStyle: { 'white-space': 'normal', 'padding-left': 0 },
            headerName: "Injected",
            headerTooltip: "Injected",
            field: "injected",
            cellRenderer: CheckboxRendererComponent,
            cellRendererParams: {
                action: this.toggleBoolean("injected"),
                field: "injected",
                description: "Injected",
                isVisible: this.canEditColumn(['PROD', 'PROD2', 'I1', 'I2', 'L1', 'T1'])
            },
            cellEditor: CheckboxEditorComponent,
            cellEditorParams: {
                action: this.toggleBoolean('injected'),
                field: 'injected',
                decription: 'Injected',
                isVisible: this.canEditColumn(['PROD', 'PROD2', 'I1', 'I2', 'L1', 'T1']),
            },
            tooltipValueGetter: this._gridFormatterService.formatBooleanToYesNo("injected"),
            editable: this.canEditColumn(['PROD', 'PROD2', 'I1', 'I2', 'L1', 'T1']),
            suppressMovable: true,
            suppressFiltersToolPanel: true,
            autoHeight: true,
            minWidth: 110
        } as ColDef);

        colDefs.push({
            headerClass: "wrapped",
            cellStyle: { 'white-space': 'normal', 'padding-left': 0 },
            headerName: 'Hydraulic Fracturing',
            headerTooltip: 'Hydraulic Fracturing',
            field: 'hydraulicFracturing',
            cellRenderer: CheckboxRendererComponent,
            cellRendererParams: {
                action: this.toggleBoolean('hydraulicFracturing'),
                field: 'hydraulicFracturing',
                description: 'Hydraulic Fracturing',
                isVisible: this.canEditColumn(['PROD', 'PROD2', 'L1', 'T1']),
            },
            cellEditor: CheckboxEditorComponent,
            cellEditorParams: {
                action: this.toggleBoolean('hydraulicFracturing'),
                field: 'hydraulicFracturing',
                description: 'Hydraulic Fracturing',
                isVisible: this.canEditColumn(['PROD', 'PROD2', 'L1', 'T1']),
            },
            tooltipValueGetter: this._gridFormatterService.formatBooleanToYesNo('hydraulicFracturing'),
            editable: this.canEditColumn(['PROD', 'PROD2', 'L1', 'T1']),
            suppressMovable: true,
            suppressFiltersToolPanel: true,
            autoHeight: true,
            minWidth: 110
        } as ColDef);

        return colDefs;
    }

    public numberColumnFormatter(fieldName: string, precision: number = 3, defaultText: string = this._defaultPlaceHolderText, validCasingTypes: string[] = this._validStringCasingTypeCodesWithoutTubing): any {
        return (obj) => {
            if (this.canEditColumn(validCasingTypes)(obj)) { 
                return this._gridFormatterService.formatNumberPrecision(fieldName, precision, defaultText)(obj);
            }
            else return "";
        }
    }

    public canEditColumn(validCasingTypes: string[] = this._validStringCasingTypeCodesWithoutTubing): (obj: any) => boolean {
        return (obj) => {
            let canEditColumn = false;

            if (!this.isEdit) {
                try {
                    if (validCasingTypes.filter(x => obj.data['casingType']['code'] == x).length > 0) {
                        canEditColumn = true;
                    }
                }
                catch (e) {
                    console.error('error in canEditColumn', e);
                }
            }

            return canEditColumn && !this._navigationStarted;
        }
    }

    public isRowSelectable(rowNode: any): boolean {
        return !this.isEdit && !this._navigationStarted;
    }

    onSchematicUpdated(schematic: string): void {
        this.casingPlan.schematic = schematic;
        this.saveCasingPlan();
        if (this.flowComponent && this.flowComponent.workflow) {
            this.loader.toggleLoader(true);
            let obs$ = this.flowComponent.saveContext().pipe(
                finalize(() => { this.loader.toggleLoader(false); })
            ).subscribe(
                () => { },
                (error) => { console.error(error); }
            );
            this.dataSubscriptions.add(obs$);
        }
    }


    toggleBoolean(fieldName: string) {
        return (obj: any) => {
            this.saveCasingPlan();
        }
    }

    updateDrawing(): void {
        this.modal.toggle(true);
    }

    public getLatitudeFromContext(): number {
        if (this.isEdit) return 0;
        const direction = this.casingPlan.wellDirection || "";
        switch (direction) {
            case WellDirection.Directional:
                return Number(this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.LatitudeDirectional) || ""));
            case WellDirection.OtherHorizontal:
            case WellDirection.Horizontal:
                return Number(this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.LatitudeHorizontal) || ""));
            case WellDirection.Vertical:
                return Number(this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.LatitudeVertical) || ""));
            default:
                return 0;
        }
    }

    public getLongitudeFromContext(): number {
        if (this.isEdit) return 0;
        const direction = this.casingPlan.wellDirection || "";
        switch (direction) {
            case WellDirection.Directional:
                return Number(this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.LongitudeDirectional) || ""));
            case WellDirection.OtherHorizontal:
            case WellDirection.Horizontal:
                return Number(this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.LongitudeHorizontal) || ""));
            case WellDirection.Vertical:
                return Number(this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.LongitudeVertical) || ""));
            default:
                return 0;
        }
    }

    public getStatePlane(): string {
        if (this.isEdit) return StatePlane.South;
        const direction = this.casingPlan.wellDirection || "";
        let plane = StatePlane.South;
        switch (direction) {
            case WellDirection.Directional:
                plane = this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.StatePlaneDirectional));
                break;
            case WellDirection.OtherHorizontal:
            case WellDirection.Horizontal:
                plane = this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.StatePlaneHorizontal));
                break;
            case WellDirection.Vertical:
                plane = this.getContextData(getContextLocation(this.componentData.config.wellDataPoints, WellConfigurationIndex.StatePlaneVertical));
                break;
            default:
                break;
        }
        return plane;
    }

    public readProposedFormations(): string[] {
        const formations = [];
        if (this.componentData.config.wellDataPoints) {
            const locations = getMultipleReadContextLocations(this.componentData.config.wellDataPoints, WellConfigurationIndex.ProposedFormation);
            for (let i = 0; i < locations.length; i++) {
                const data = this.getContextData(locations[i]);
                if (isDefined(data)) {
                    formations.push(data);
                }
            }
        }
        return formations;
    }

    isCasingPlanValid(): boolean {
        if ((this.requirePositions && (!this.positionsValid || !this.positionsDistinct)) || !this.measurementsValid) return false;
        if (this.casingPlan == null || this.casingPlan.wellSegments == null) return false;
        const segmentsValid = this.casingPlan.wellSegments.map(m => this.hasFieldBeenSet(m));
        const hasValidSegment = segmentsValid.findIndex(s => s === true) !== -1
        if (hasValidSegment) {
            this.formGroup.controls[this.componentData.key].setErrors(null);
        }
        return hasValidSegment;
        
    }

    hasFieldBeenSet(segment: WellSegmentModel): boolean {
        let aFieldHasBeenSet: boolean = false;
        if (this.isFieldSet(segment.boreholeDiameter)
            || this.isFieldSet(segment.boreholeDepth)
            || this.isFieldSet(segment.casingDiameter)
            || this.isFieldSet(segment.casingLength)
            || this.isFieldSet(segment.cementVolume)
            || this.isFieldSet(segment.packerDepth)
            || this.isFieldSet(segment.numberCentralizers)) {
            aFieldHasBeenSet = true;
        }       
        if (aFieldHasBeenSet === true) {
            const numberFormats: boolean[] = [];
            if (this.isFieldSet(segment.boreholeDiameter)) {
                numberFormats.push(!isNaN(segment.boreholeDiameter));
            }
            if (this.isFieldSet(segment.boreholeDepth)) {
                numberFormats.push(!isNaN(segment.boreholeDepth));
            }
            if (this.isFieldSet(segment.casingDiameter)) {
                numberFormats.push(!isNaN(segment.casingDiameter));
            }
            if (this.isFieldSet(segment.casingLength)) {
                numberFormats.push(!isNaN(segment.casingLength));
            }
            if (this.isFieldSet(segment.cementVolume)) {
                numberFormats.push(!isNaN(segment.cementVolume));
            }
            if (this.isFieldSet(segment.packerDepth)) {
                numberFormats.push(!isNaN(segment.packerDepth));
            }
            if (this.isFieldSet(segment.numberCentralizers)) {
                numberFormats.push(!isNaN(segment.numberCentralizers));
            }
            if (numberFormats.length > 0) {
                aFieldHasBeenSet = numberFormats.findIndex(n => n === false) === -1;
            }
        }
        return aFieldHasBeenSet
    }

    public saveCasingPlan() {      
        if (this.enableEditing) {
            this.casingPlan.wellSegments = this.organizeWellStrings(this.data);
            if (this.isCasingPlanValid()) {
                this.setContextValue(this.casingPlan);
            }
            else {
                this.setContextValue("");
            }

            this.validateControl();
            super.change();
        }       
    }

    isFieldSet(fieldValue: any): boolean {
        return fieldValue != null && fieldValue != undefined && fieldValue != "" && !isNaN(fieldValue) ? true : false;
    }

    private organizeWellStrings(segments: WellSegmentModel[]): WellSegmentModel[] {
        const topInferredTypes: string[] = ["HOL1", "L1"];
        const positionedStrings = segments.filter(s => s.position != null && s.position > 0);
        const nonPositionedStrings = segments.filter(s => s.position == null || s.position === 0);
        const packer = segments.find(s => s.casingType.code === 'PKR');
        const sortedPositioned = positionedStrings.sort((a, b) => {
            if (a.position > b.position) return 1;
            if (a.position < b.position) return -1;
            return 0;
        });
        for (let p = 0; p < sortedPositioned.length; p++) {
            const segment: WellSegmentModel = sortedPositioned[p];
            segment.hasData = true;
            let topStart: number = 0; 
            if (p > 0 && topInferredTypes.findIndex(t => t == segment.casingType.code) !== -1) {
                const previousSegment = sortedPositioned[p - 1];
                topStart = Number(previousSegment.casingBottom);
            }
            if (segment.boreholeDepth != null && segment.boreholeDepth.toString() !== "") {
                segment.boreholeTop = topStart;
                segment.boreholeDepth = Number(segment.boreholeDepth);
                segment.boreholeBottom = topStart + segment.boreholeDepth;
            }
            if (segment.casingLength != null && segment.casingLength.toString() !== "") {
                segment.casingTop = topStart;
                segment.casingLength = Number(segment.casingLength);
                segment.casingBottom = topStart + segment.casingLength;
            }
            if (segment.cementTop != null && segment.boreholeBottom != null) {
                segment.cementBottom = segment.boreholeBottom;
            }
        }
        sortedPositioned.forEach(p => p.packerDepth = null); //to reset any place the packer may currently be listed to keep it from being listed twice
        if (packer != null && packer.casingLength > 0) {
            let pos: number = 0;
            
            packer.casingLength = Number(packer.casingLength);
            for (let p = 0; p < sortedPositioned.length; p++) {
                let segment = sortedPositioned[p];
                pos = pos + segment.casingBottom;
                if (packer.casingLength < pos) {
                    segment.packerDepth = packer.casingLength;
                    break;
                }
            }
        } 
        nonPositionedStrings.forEach(s => {
            const hasData = segmentHasData(s);
            s.hasData = hasData;
        });
        let sorted: WellSegmentModel[] = [];
        sorted = positionedStrings.concat(nonPositionedStrings); //should put all non-positioned strings to the bottom of the list
        sorted.forEach(s => {
            if (s.boreholeDiameter != null && s.boreholeDiameter.toString() !== "") s.boreholeDiameter = Number(s.boreholeDiameter);
            if (s.casingDiameter != null && s.casingDiameter.toString() !== "") s.casingDiameter = Number(s.casingDiameter);
            if (s.cementTop != null && s.cementTop.toString() !== "") s.cementTop = Number(s.cementTop);
            if (s.cementVolume != null && s.cementVolume.toString() !== "") s.cementVolume = Number(s.cementVolume);
        });
        return sorted;
    }

    /**
   * Validates the control manually
   */
    public validateControl(): void {
        if (!this.componentData.contextTarget) {
            console.warn(`There is no context target configured - can't save casing plan.`);
            return;
        }

        let value: any = this.contextValue;
        this.formControl.setValue(value);
        this.formControl.markAsTouched();
        this.formControl.markAsDirty();
    };

    protected _decrementFunction(button: Button): void {
        this.saveCasingPlan();
        this._navigationStarted = true;
        this.buttonOverride.callOriginalFunction(button);
    }

    protected _incrementFunction(button: Button): void {
        for (let i = 0; i < this.data.length; i++) {
            let segment: WellSegmentModel = this.data[i];
            if (segment.position != null && segment.position > 0) {
                if (!this.hasFieldBeenSet(segment)) {
                    segment.position = null; //void out any segments that only have a position value set, prior to saving
                }
            }
        }
        this.saveCasingPlan();
        this._navigationStarted = true;        
        this.buttonOverride.callOriginalFunction(button);
    }

    tabToNextCell(params: TabToNextCellParams): CellPosition {  
        let result: CellPosition = null;
        let currentColumn = this.gridOptions.columnDefs.findIndex(c => (c as ColDef).field == params.previousCellPosition.column.getColDef().field);
        
        if (currentColumn != -1) {
            if (params.backwards) {                
                let initialRow = (currentColumn === 0) ? params.previousCellPosition.rowIndex - 1 : params.previousCellPosition.rowIndex;
                if (currentColumn === 0) currentColumn = this.gridOptions.columnDefs.length - 1;
                for (let r = initialRow; r >= 0; r--) {                    
                    for (let c = currentColumn - 1; c >= 0; c--) {
                        let columnDef = <ColDef>this.gridOptions.columnDefs[c];
                        let column = this.gridApi.getColumn(columnDef.field);
                        let rowNode = this.gridApi.getDisplayedRowAtIndex(r);
                        if (column.isCellEditable(rowNode)) {
                            result = <CellPosition>{
                                rowIndex: r,
                                column: column,
                                rowPinned: params.previousCellPosition.rowPinned
                            };
                        }
                        if (result != null) break;
                    }
                    if (result != null) break;
                    currentColumn = this.gridOptions.columnDefs.length - 1;
                }
            }
            else {
                for (let r = params.previousCellPosition.rowIndex; r < this.data.length; r++) {
                    for (let c = currentColumn + 1; c < this.gridOptions.columnDefs.length; c++) {
                        let columnDef = <ColDef>this.gridOptions.columnDefs[c];
                        let column = this.gridApi.getColumn(columnDef.field);
                        let rowNode = this.gridApi.getDisplayedRowAtIndex(r);
                        if (column.isCellEditable(rowNode)) {
                            result = <CellPosition>{
                                rowIndex: r,
                                column: column,
                                rowPinned: params.previousCellPosition.rowPinned
                            };
                        }
                        if (result != null) break;
                    }
                    if (result != null) break;
                    currentColumn = -1;
                }
            }
        }        
        return result;
    }
}
